import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CancelIcon from "@mui/icons-material/Cancel";
import "../App.css";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Autocomplete from "./Autocomplete";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useAppDispatch, useAppSelector } from "../Redux/store/hooks";
import {
  clearStrategiesList,
  list_StrategiesList,
} from "../Redux/Reducers/Strategies_api/list_StrategiesList_slicer";
import { list_LiveTrade } from "../Redux/Reducers/Open-Position/list_LiveTrade_slicer";
import { edit_filterlive } from "../Redux/Reducers/Filtervalue/filterlive";
import { useState } from "react";
import { list_AddorEditList } from "../Redux/Reducers/Trade-setup/listaddoredit_Trade-setup_slicer";

type Anchor = "top" | "left" | "bottom" | "right";

export default function LiveTradefilter(props: any) {
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setState({ ...state, [anchor]: open });
    };

  const dispatcher = useAppDispatch();

  // filter the aglo name
  const Filterlive: any = useAppSelector((state) => state?.filterlive?.data);
  const AddorEdit: any = useAppSelector((state) => state?.AddorEditList?.data);
  const uniqueIds = Array.from(new Set(AddorEdit.map((v: any) => v?.algo?.id)));

  React.useEffect(() => {
    dispatcher(list_AddorEditList(""));
  }, [dispatcher]);

  return (
    <div>
      {(["right"] as const).map((anchor) => (
        <React.Fragment key={anchor}>
          <span title="Filter">
            <FilterListIcon
              onClick={toggleDrawer(anchor, true)}
              sx={{
                marginTop: "5px",
                fontSize: "24px",
                marginRight: "5px",
                marginLeft: "10px",
                cursor: "pointer",
              }}
            ></FilterListIcon>
          </span>

          <Drawer anchor={anchor} open={state[anchor]}>
            <Box
              sx={{
                width: {
                  xs: 200,
                  sm: 200,
                  md: 300,
                  lg: 360,
                  xl: 400,
                },
                zIndex: "1",
              }}
              role="presentation"
            >
              <div
                style={{
                  display: "flex",
                  backgroundColor: "#2C8E14",
                  justifyContent: "space-between",
                  height: "64px",
                }}
              >
                <span
                  style={{
                    padding: "17px",
                    fontSize: "20px",
                    color: "white",
                    fontFamily: "Roboto",
                  }}
                >
                  Filter
                </span>
                <div style={{ padding: "20px", cursor: "pointer" }}>
                  <CancelIcon
                    sx={{ color: "white" }}
                    onClick={toggleDrawer(anchor, false)}
                  ></CancelIcon>
                </div>
              </div>
              <Formik
                initialValues={{
                  status: Filterlive?.status ?? null, // Set the initial value here
                  algo_id: Filterlive?.algo_id ?? null,
                  strategy_id: Filterlive?.strategy_id ?? null,
                  id_for_filterstrategy:
                    Filterlive?.id_for_filterstrategy ?? null,
                }}
                validationSchema={Yup.object().shape({})}
                onSubmit={(values) => {
                  dispatcher(
                    list_LiveTrade({
                      ...values,
                      type: props.filtertype,
                      entry_type: props.entry_type,
                    })
                  );
                  dispatcher(edit_filterlive(values));
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleSubmit,
                  handleBlur,
                  setFieldValue,
                }) => (
                  <Form onSubmit={handleSubmit}>
                    <div
                      style={{
                        color: "#000000",
                        padding: "10px 0px 0px 20px",
                        fontSize: "14px",
                        fontFamily: "Roboto",
                      }}
                    >
                      Select Algo
                    </div>
                    <Autocomplete
                      Listitem={uniqueIds.map((id) => {
                        const item = AddorEdit.find(
                          (v: any) => v?.algo.id === id
                        );
                        return {
                          label: item.algo.name,
                          value: item.algo.id,
                        };
                      })}
                      variant={"outlined"}
                      name={"algo_id"}
                      value={values}
                      size={"medium"}
                      onBlur={handleBlur}
                      onchange={(e: any, newValue: any) => {
                        setFieldValue("algo_id", e.value);
                        setFieldValue("id_for_filterstrategy", e.value);

                        dispatcher(
                          list_StrategiesList({
                            algo_id: e.value,
                            is_enabled: true,
                          })
                        );
                        setFieldValue("strategy_id", null);
                      }}
                      style={{
                        padding: "5px 20px 0px 20px ",
                        width: "100%",
                      }}
                    ></Autocomplete>

                    <div
                      style={{
                        color: "#000000",
                        padding: "10px 0px 0px 20px",
                        fontSize: "14px",
                        fontFamily: "Roboto",
                      }}
                    >
                      Select Strategy
                    </div>
                    <Autocomplete
                      Listitem={AddorEdit.filter(
                        (val: any) =>
                          val?.algo?.id === values.id_for_filterstrategy
                      ).flatMap((val: any) =>
                        val.strategy.map((v: any) => ({
                          label: v.name,
                          value: v.id,
                        }))
                      )}
                      variant={"outlined"}
                      name={"strategy_id"}
                      value={values}
                      size={"medium"}
                      onBlur={handleBlur}
                      onchange={(e: any, newValue: any) => {
                        setFieldValue("strategy_id", e.value);
                      }}
                      style={{
                        padding: "5px 20px 0px 20px ",
                        width: "100%",
                      }}
                    ></Autocomplete>
                    <div
                      className="bottom_div"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        backgroundColor: "#2C8E14",
                        width: "100%",
                        gap: "1em",
                        height: "60px",
                        padding: "10px",
                      }}
                    >
                      <div>
                        <span onClick={toggleDrawer(anchor, false)}>
                          <button
                            type="button"
                            onClick={() => {
                              dispatcher(
                                list_LiveTrade({ type: props.filtertype })
                              );
                              dispatcher(
                                edit_filterlive({
                                  status: null,
                                  strategy_id: null,
                                  algo_id: null,
                                })
                              );
                              dispatcher(clearStrategiesList());

                              toggleDrawer(anchor, false);
                            }}
                            style={{
                              width: "100px",
                              height: "40px",
                              color: "black",
                              backgroundColor: "white",
                              borderRadius: "5px",
                              fontFamily: "Roboto",
                              border: "1px solid #F2A618",
                            }}
                          >
                            Reset
                          </button>
                        </span>
                      </div>
                      <div>
                        <span onClick={toggleDrawer(anchor, false)}>
                          <button
                            type="submit"
                            style={{
                              width: "100px",
                              height: "40px",
                              color: "black",
                              background: !props.isValid
                                ? "linear-gradient(to right, #FFFA02,#F2A618 )"
                                : "linear-gradient(to right, #FFFA02,#F2A618 )",

                              borderRadius: "5px",
                              fontFamily: "Roboto",
                            }}
                          >
                            Save
                          </button>
                        </span>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </Box>
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}
